import React, { useEffect, useState } from 'react';
import AppSidebar from './AppSidebar';
import AppContentView from '../../AppContentView';
import AppHeader from './AppHeader';
import clsx from 'clsx';
import Box from '@mui/material/Box';
import MiniSidebarToggleWrapper from './MiniSidebarToggleWrapper';
import AppFixedFooter from './AppFixedFooter';
import { useLayoutContext } from '@projectK/context/LayoutContextProvider';
import { LayoutType } from '@projectK/constants/AppEnums';
import MiniSidebarToggleContainer from './MiniSidebarToggleContainer';
import { useLocation } from 'react-router-dom';
import PropsTypes from 'prop-types';
import jwtAxios from '@projectK/services/auth/JWT';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const MiniSidebarToggle = ({ routes, routesConfig }) => {
  const { pathname } = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const { footer, layoutType, headerType, footerType } = useLayoutContext();
  const [settings, setSettings] = useState(null);
  const { isMobile } = useMobileSettings();
  const fetchSettings = async () => {
    try {
      const response = await jwtAxios.get(`/app-settings/`);
      setSettings(response.data);
    } catch (error) {
      // Handle error
      console.error('Error fetching appearance settings:', error);
      if (error?.response?.data?.error === 'No Subdomain found') {
        window.location.href = `${process.env.NX_BASE_DOMAIN}/404`;
      }
    }
  };
  useEffect(() => {
    fetchSettings();
  }, []);
  const toggleNavCollapsed = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };
  useEffect(() => {
    if (isNavCollapsed) setIsNavCollapsed(!isNavCollapsed);
  }, [pathname]);

  return (
    <MiniSidebarToggleContainer
      className={clsx({
        boxedLayout: layoutType === LayoutType.BOXED,
        framedLayout: layoutType === LayoutType.FRAMED,
      })}
    >
      <MiniSidebarToggleWrapper
        className={clsx('miniSidebarToggleWrapper', {
          'mini-sidebar-collapsed': isCollapsed,
          appMainFooter: footer && footerType === 'fluid',
          appMainFixedFooter: footer && footerType === 'fixed',
          appMainFixedHeader: headerType === 'fixed',
        })}
        style={{
          ...(isMobile && { paddingTop: '0px' }),
        }}
      >
        <AppSidebar
          routesConfig={routesConfig}
          isNavCollapsed={isNavCollapsed}
          toggleNavCollapsed={toggleNavCollapsed}
        />
        <Box className='mainContent payment-issue-header'>
          <AppHeader
            setCollapsed={setIsCollapsed}
            isCollapsed={isCollapsed} //this is one for side nav header
            toggleNavCollapsed={toggleNavCollapsed}
          />
          <AppContentView routes={routes} settings={settings} />
          <AppFixedFooter />
        </Box>
      </MiniSidebarToggleWrapper>
    </MiniSidebarToggleContainer>
  );
};

MiniSidebarToggle.propTypes = {
  routes: PropsTypes.object,
  routesConfig: PropsTypes.array,
};
export default MiniSidebarToggle;
